import { Components, Theme } from '@mui/material/styles';

export const components: Components<Theme> = {
  // Button components
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 8,
        textTransform: 'none',
        fontWeight: 600,
        minHeight: 40,
        boxShadow: 'none',
        '&:hover': {
          boxShadow: 'none',
        },
      },
      sizeLarge: {
        minHeight: 48,
        fontSize: '1rem',
        padding: '12px 24px',
      },
      sizeMedium: {
        minHeight: 40,
        fontSize: '0.875rem',
        padding: '8px 16px',
      },
      sizeSmall: {
        minHeight: 32,
        fontSize: '0.75rem',
        padding: '6px 12px',
      },
    },
  },

  // Input components
  MuiTextField: {
    defaultProps: {
      variant: 'outlined',
    },
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-root': {
          borderRadius: 8,
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#2E5BBA',
          },
        },
      },
    },
  },

  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        borderRadius: 8,
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: '#2E5BBA',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: '#2E5BBA',
          borderWidth: 2,
        },
      },
      input: {
        padding: '12px 14px',
        fontSize: '0.875rem',
      },
    },
  },

  // Card components
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: 12,
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
        border: '1px solid #E5E7EB',
        '&:hover': {
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        },
      },
    },
  },

  MuiCardContent: {
    styleOverrides: {
      root: {
        padding: 24,
        '&:last-child': {
          paddingBottom: 24,
        },
      },
    },
  },

  // Modal components
  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: 16,
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
      },
    },
  },

  MuiDialogTitle: {
    styleOverrides: {
      root: {
        fontSize: '1.25rem',
        fontWeight: 600,
        padding: '24px 24px 16px',
      },
    },
  },

  MuiDialogContent: {
    styleOverrides: {
      root: {
        padding: '0 24px 16px',
      },
    },
  },

  MuiDialogActions: {
    styleOverrides: {
      root: {
        padding: '16px 24px 24px',
        gap: 8,
      },
    },
  },

  // AppBar components
  MuiAppBar: {
    styleOverrides: {
      root: {
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
        backgroundColor: '#FFFFFF',
        color: '#111827',
        borderBottom: '1px solid #E5E7EB',
      },
    },
  },

  // Toolbar components
  MuiToolbar: {
    styleOverrides: {
      root: {
        minHeight: 64,
        paddingLeft: 24,
        paddingRight: 24,
      },
    },
  },

  // Loading components
  MuiCircularProgress: {
    styleOverrides: {
      root: {
        color: '#2E5BBA',
      },
    },
  },

  // Alert components
  MuiAlert: {
    styleOverrides: {
      root: {
        borderRadius: 8,
        fontSize: '0.875rem',
      },
      standardError: {
        backgroundColor: '#FEF2F2',
        color: '#991B1B',
      },
      standardWarning: {
        backgroundColor: '#FFFBEB',
        color: '#92400E',
      },
      standardInfo: {
        backgroundColor: '#EFF6FF',
        color: '#1D4ED8',
      },
      standardSuccess: {
        backgroundColor: '#ECFDF5',
        color: '#047857',
      },
    },
  },
};

export default components;